module.exports = __webpack_public_path__ + "static/media/User.f57bf932.svg";